import standardAPI from '@/api/standard_items';

const state = {
  price_cart_types: [],
  price_cart_types_status: '',
  price_cart_types_MetaData: {},
  price_cart_types_page: 1,
  price_cart_types_perPage: 10,
};

const responseUrl = '/price-cart-types';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_price_cart_types ({ commit }, getOptions) {
    commit('PRICE_CART_TYPES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('PRICE_CART_TYPES_SUCCESS', response);
            commit('PRICE_CART_TYPES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('PRICE_CART_TYPES_READY');
            reject(response);
          } else {
            commit('PRICE_CART_TYPES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_price_cart_type ({ commit, dispatch }, itemData) {
    commit('PRICE_CART_TYPES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('PRICE_CART_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  edit_price_cart_type ({ commit, dispatch }, itemData) {
    commit('PRICE_CART_TYPES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('PRICE_CART_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  remove_price_cart_type ({ commit, dispatch }, itemData) {
    commit('PRICE_CART_TYPES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'preDeleted') {
          resolve(response);
        } else {
          commit('PRICE_CART_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_price_cart_type ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.price_cart_types_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.price_cart_types_perPage = max;
  },
  PRICE_CART_TYPES_READY: (state) => {
    state.price_cart_types_status = 'ready';
  },
  PRICE_CART_TYPES_REQUEST: (state) => {
    state.price_cart_types_status = 'loading';
  },
  PRICE_CART_TYPES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.price_cart_types_MetaData.meta = response.meta;
      state.price_cart_types_MetaData.links = response.links;
    }
    state.price_cart_types = response.data;
    state.price_cart_types_status = 'success';
  },
  PRICE_CART_TYPES_ERROR: (state) => {
    state.price_cart_types_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
